export const logUserFeedbackEndpoint = state => `${state.config.apiUrl}/v1/feedback`;
export const promptUserFeedbackEndpoint = state => `${state.config.apiUrl}/v1/promptFeedback`;



// WEBPACK FOOTER //
// ./src/services/feedback/selectors.js